import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import WOW from "wowjs";
// import Image from "../images/mt_everest.jpg"; // Ensure you have the correct image
import AcclimatizationImage from "../images/acclimatization.jpg"; // Image for acclimatization (use relevant image path)
import "../App.css"; // Ensure to include your custom CSS here

const Altitude = () => {
  useEffect(() => {
    new WOW.WOW({ live: false }).init();
  }, []);

  return (
    <section className="about-section py-5">
      <Container>
        {/* New Section for Acclimatization and Medical Problems at High Altitude */}
        <Row className="mt-5">
          <h2 className="text-center mb-4" style={{ fontSize: "40px" }}>
            Physiology and Pathology at High Altitude
          </h2>

          {/* Content Section */}
          <Col
            md={6}
            className="wow animate__animated animate__fadeInLeft"
            data-wow-duration="1.5s"
          >
            <p className="text-muted" style={{ lineHeight: "1.8em" }}>
              <strong>What Is High Altitude?</strong> Altitude above 8000 feet is called high altitude. At these heights, the body suffers from hypoxia, a condition where oxygen supply to the body's tissues becomes inadequate due to thinner air and decreased partial pressure of oxygen.
              <br />
              <br />
              <strong>How does the body adapt?</strong> The body goes through acclimatization to adjust to the lower oxygen levels. This process involves faster breathing, increased red blood cell production, and other physiological changes to optimize oxygen delivery and utilization.
              <br />
              <br />
              <strong>High Altitude Illnesses:</strong>
              <ul>
                <li>Acute Mountain Sickness (AMS)</li>
                <li>High Altitude Pulmonary Edema (HAPE)</li>
                <li>High Altitude Cerebral Edema (HACE)</li>
              </ul>
            </p>

            <a
              href={`${process.env.PUBLIC_URL}/Acclimatization-&-Medical-Problems-at-High-Altitude.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ width: "250px" }}
            >
              Read More
            </a>
          </Col>

          {/* Image Section for Acclimatization */}
          <Col
            md={6}
            className="wow animate__animated animate__fadeInRight"
            data-wow-duration="1.5s"
          >
            <div className="image-wrapper position-relative">
              <img
                src={AcclimatizationImage}
                alt="Acclimatization"
                className="img-fluid rounded shadow"
                style={{
                  border: "2px solid ",
                  padding: "5px",
                  marginTop: "10px",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Altitude;
